import { Classes, Dialog } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { InscriptionApi, InscriptionSansSuiteDto } from "../../../../../api";
import * as Yup from "yup";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { FGWalterDateMaskInput, SmallFormGenerator } from "../../../../../components";
import { FieldGroup } from "nsitools-react";

const StyledDialog = styled(Dialog)`
  width: 500px;
  height: auto;
  background-color: white;
`;

export interface IInscriptionSansSuiteDetailDialogProps {
  dialogOpen: boolean;
  onClose: (toSave?: InscriptionSansSuiteDto) => void;
  currentSansSuite: InscriptionSansSuiteDto;
}

export const InscriptionSansSuiteDetailDialog: React.FunctionComponent<IInscriptionSansSuiteDetailDialogProps> = ({
  currentSansSuite,
  dialogOpen,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(InscriptionApi);

  const { data, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => currentSansSuite,
        saveApiFn: async d => {
          await api.inscriptionSansSuite({ InscriptionSansSuiteDto: d });
          return d;
        },
        onSaved: d => onClose(d),
        serverValidationRootKey: "Dto"
      }),
      [api, currentSansSuite, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        dateSansSuite: Yup.date()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  return (
    <StyledDialog title={t(ETLCodes.DateSansSuite)} isOpen={dialogOpen} onClose={() => onClose()}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose()}
          showDeleteButton={false}
          saving={saving}
          minLabelWidth={100}
          validationErrors={validationErrors}
          preventDefaultSaveOnEnter
        >
          <FieldGroup>
            <FGWalterDateMaskInput name="dateSansSuite" label={t(ETLCodes.DateSansSuite)} />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
